export const en = () => import('./en.json');
export const sv = () => import('./sv.json');
export const et = () => import('./et.json');
export const fi = () => import('./fi.json');
export const lv = () => import('./lv.json');
export const ru = () => import('./ru.json');
export const da = () => import('./da.json');
